/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnershipHighlights
 */
export interface PartnershipHighlights {
    /**
     * Total number of members in the organization
     * @type {number}
     * @memberof PartnershipHighlights
     */
    numberOfTeamMembers: number;
    /**
     * Total number of completed projects
     * @type {number}
     * @memberof PartnershipHighlights
     */
    numberOfProjects: number;
    /**
     * Average rating of freelancers across all projects (can be null if no ratings available)
     * @type {number}
     * @memberof PartnershipHighlights
     */
    averageFreelancerRating?: number;
    /**
     * Number of freelancers in the company's pool
     * @type {number}
     * @memberof PartnershipHighlights
     */
    numberOfFreelancersInPool: number;
}

/**
 * Check if a given object implements the PartnershipHighlights interface.
 */
export function instanceOfPartnershipHighlights(value: object): value is PartnershipHighlights {
    if (!('numberOfTeamMembers' in value) || value['numberOfTeamMembers'] === undefined) return false;
    if (!('numberOfProjects' in value) || value['numberOfProjects'] === undefined) return false;
    if (!('numberOfFreelancersInPool' in value) || value['numberOfFreelancersInPool'] === undefined) return false;
    return true;
}

export function PartnershipHighlightsFromJSON(json: any): PartnershipHighlights {
    return PartnershipHighlightsFromJSONTyped(json, false);
}

export function PartnershipHighlightsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnershipHighlights {
    if (json == null) {
        return json;
    }
    return {
        
        'numberOfTeamMembers': json['numberOfTeamMembers'],
        'numberOfProjects': json['numberOfProjects'],
        'averageFreelancerRating': json['averageFreelancerRating'] == null ? undefined : json['averageFreelancerRating'],
        'numberOfFreelancersInPool': json['numberOfFreelancersInPool'],
    };
}

export function PartnershipHighlightsToJSON(value?: PartnershipHighlights | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberOfTeamMembers': value['numberOfTeamMembers'],
        'numberOfProjects': value['numberOfProjects'],
        'averageFreelancerRating': value['averageFreelancerRating'],
        'numberOfFreelancersInPool': value['numberOfFreelancersInPool'],
    };
}

